import { lazy } from "react";
import PasswordContextProvider from "../contexts/PasswordContext";
import { ProtectedRoute } from "../components/ProtectedRoute.jsx";

const confidentialRequestRouteConfig = [
  {
    index: true,
    component: lazy(() =>
      import("../routes/confidential/requesting/DocumentConfidentialRequesting.jsx")
    ),
    wrapper: PasswordContextProvider,
  },
  {
    path: "new-request",
    component: lazy(() => import("../routes/confidential/requesting/ConfidentialNewRequest.jsx")),
  },
  {
    path: "update-request/:id",
    component: lazy(() =>
      import("../routes/confidential/requesting/ConfidentialUpdateRequest.jsx")
    ),
  },
  {
    path: "returned-requests",
    component: lazy(() =>
      import("../routes/confidential/requesting/returned/ReturnedConfidentialDocument.jsx")
    ),
  },
  {
    path: "transaction-request",
    component: lazy(() => import("../routes/requestor/new/TransactionRequest")),
  },
];

const confidentialRouteConfig = [
  {
    parent: {
      exact: true,
      path: "/confidential/tagging",
      element: ProtectedRoute,
      permission_id: 28,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() =>
        import("../routes/confidential/tagging/DocumentConfidentialTagging.jsx")
      ),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/confidential/tagging/returned-documents",
      element: ProtectedRoute,
      permission_id: 28,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() =>
        import("../routes/confidential/tagging/returned/ReturnedConfidentialTaggingDocument.jsx")
      ),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/confidential/voucher/vouchering",
      element: ProtectedRoute,
      permission_id: 28,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() =>
        import("../routes/confidential/vouchering/DocumentConfidentialVouchering")
      ),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/confidential/voucher/returned-vouchers",
      element: ProtectedRoute,
      permission_id: 28,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() =>
        import(
          "../routes/confidential/vouchering/returned/ReturnedConfidentialVoucheringDocument.jsx"
        )
      ),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/confidential/approving",
      element: ProtectedRoute,
      permission_id: 18,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() =>
        import("../routes/confidential/approving/DocumentConfidentialApproving")
      ),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/confidential/transmitting",
      element: ProtectedRoute,
      permission_id: 13,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() =>
        import("../routes/confidential/transmitting/DocumentConfidentialTransmitting")
      ),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/confidential/releasing",
      element: ProtectedRoute,
      permission_id: 13,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() =>
        import("../routes/confidential/releasing/DocumentConfidentialReleasing")
      ),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/confidential/filing",
      element: ProtectedRoute,
      permission_id: 13,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/confidential/filing/DocumentConfidentialFiling")),
      wrapper: PasswordContextProvider,
    },
  },
];

export { confidentialRouteConfig };
export default confidentialRequestRouteConfig;
